'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const feed = css`
  scroll-snap-align: start;
`;

export const global = css`
  :global() {
    html:has(.${feed}) {
      scroll-snap-type: y mandatory;
      scroll-snap-stop: always;
      scroll-padding-top: 60px;
      @media screen and (width > ${theme.sizes.screens.md}) {
        scroll-snap-type: none;
      }
    }
  }
`;
